<div class="container">
  <div class="help-container">
    <div class="boxs-container">
      <span class="title">{{ 'pages.help_view.need_help' | translate }}</span>
      <br />
      <span
        >{{ 'pages.help_view.text_1' | translate }}
        <span class="resaltado">{{ 'pages.help_view.text_phone' | translate }} </span>
        {{ 'pages.help_view.text_3' | translate }}
      </span>
      <div style="margin-top: 50px">
        <span class="title"> {{ 'pages.help_view.preguntas_frecuentes' | translate }} </span><br />
        <span>
          {{ 'pages.help_view.text_questions' | translate }}
          <a class="resaltado" href="https://www.fiserv.com.ar/servicios/pagos-con-pix/" target="_blank"
            >https://www.fiserv.com.ar/servicios/pagos-con-pix/</a
          >
        </span>
      </div>
      <br />
    </div>
  </div>
  <div class="version-container">
    <span> Versión: {{ version }} </span>
    <span> Dispositivo: {{ environment }} </span>
    <span *ngIf="environment === deviceEnvironmentId.CLOVER"> Terminal: {{ terminalId ? terminalId : '-' }} </span>
  </div>
</div>
